import ReservationVue from '@/views/sic/reservation/reservation.vue';

const basePath = '/sic/reservation';
const role = 'sic'; // 角色身份

export const SIC_RESERVATION_INDEX = 'sic-reservation-index';
export const SIC_RESERVATION_EDIT = 'sic-reservation-edit';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: ReservationVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: SIC_RESERVATION_INDEX,
      component: () => import(
        /* webpackChunkName: "reservation-index" */
        `@/views/${role}/reservation/index.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    },
    {
      path: `${basePath}/edit/:id`,
      name: SIC_RESERVATION_EDIT,
      props: true,
      component: () => import(
        /* webpackChunkName: "reservation-edit" */
        `@/views/${role}/reservation/edit.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
